import facePhoto from './_face-photo';
import ticketType from './_ticket-type';

export default function(data){
  const id = data.id;
  const cover = data.cover;
  const ticket_type = cover.querySelector(`input[name=チケット区分${id}]`);
  const face_photo = cover.querySelector(`input[name=顔写真${id}]`);

  if(id != '' && ticket_type.type == 'hidden' && ticket_type.value == '') cover.style.display = 'none';

  facePhoto.setEvent(cover, face_photo);
  ticketType.setEvent(cover, ticket_type, id);

}
